import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { useRoute } from '@nuxtjs/composition-api';
import { SCheckbox } from '@strana-artw/ui-kit';
import { useVuelidate } from '@vuelidate/core';
import { sameAs } from '@vuelidate/validators';
import { storeToRefs } from 'pinia';
import { computed, defineComponent, reactive, watch } from 'vue';
import { useUserRole } from '@/shared/composables';
import { LEGAL_DOCUMENTS_SLUGS } from '@/shared/constants';
import { useAuthStore } from '@/store/authStore';
export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationPolicy',
  props: {
    target: {
      type: String,
      default: '_blank'
    },
    hiddenOfferBlock: {
      type: Boolean,
      default: false
    }
  },
  emits: ["policy-checked"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    defineComponent({
      name: 'RegistrationPolicy'
    });
    var isAgent = computed(function () {
      var _route$value$name;
      var route = useRoute();
      if ((_route$value$name = route.value.name) !== null && _route$value$name !== void 0 && _route$value$name.includes('registration')) {
        var _route$value$name2;
        return (_route$value$name2 = route.value.name) === null || _route$value$name2 === void 0 ? void 0 : _route$value$name2.includes('agents');
      }
      var _useUserRole = useUserRole(),
        isAgent = _useUserRole.isAgent;
      return isAgent;
    });
    var links = computed(function () {
      var path = '/legal-documents';
      return {
        accept: "".concat(path, "/").concat(LEGAL_DOCUMENTS_SLUGS.accept),
        politic: "".concat(path, "/").concat(LEGAL_DOCUMENTS_SLUGS.politic),
        brokerOffer: "".concat(path, "/").concat(LEGAL_DOCUMENTS_SLUGS.brokerOffer),
        brokerLoyaltyProgram: "".concat(path, "/").concat(LEGAL_DOCUMENTS_SLUGS.brokerLoyaltyProgram)
      };
    });
    var authStore = useAuthStore();
    var _storeToRefs = storeToRefs(authStore),
      isAggregator = _storeToRefs.isAggregator;
    var isShowOffersBlock = computed(function () {
      if (isAgent.value) {
        return true;
      }
      if (isAggregator.value) {
        return false;
      }
      return !props.hiddenOfferBlock;
    });
    var state = reactive({
      form: {
        acceptPolicy: false,
        acceptOffer: false
      }
    });
    var rules = {
      form: {
        acceptPolicy: {
          sameAs: sameAs(true)
        },
        acceptOffer: {
          sameAs: sameAs(true)
        }
      }
    };
    var v$ = useVuelidate(rules, state);
    function checkedPolicy() {
      var value = {
        acceptPolicy: v$.value.form.acceptPolicy.$model,
        acceptOffer: isAgent.value || !isAggregator.value ? v$.value.form.acceptOffer.$model : true
      };
      emit('policy-checked', value);
    }
    watch(function () {
      return props.hiddenOfferBlock;
    }, function () {
      v$.value.form.acceptOffer.$model = false;
      v$.value.form.acceptPolicy.$model = false;
    });
    watch(function () {
      return v$.value.form.acceptPolicy.$model;
    }, function () {
      return checkedPolicy();
    });
    watch(function () {
      return v$.value.form.acceptOffer.$model;
    }, function () {
      return checkedPolicy();
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      isAgent: isAgent,
      links: links,
      authStore: authStore,
      isAggregator: isAggregator,
      isShowOffersBlock: isShowOffersBlock,
      state: state,
      rules: rules,
      v$: v$,
      checkedPolicy: checkedPolicy,
      SCheckbox: SCheckbox
    };
  }
});